export enum PermissionStatus {
    Prompt = 'prompt',
    Denied = 'denied',
    Granted = 'granted'
}

export enum PermissionNames {
    ClipboardRead = 'clipboard-read',
    ClipboardWrite = 'clipboard-write'
}